import React, { useEffect, useState } from "react";
import { Toolbar, Typography } from "@mui/material";
import UsersTable from "../../../components/usersTable/UsersTable";
import "./styles.scss";
import { getAllUsers, getUserDetails } from "../../../services/userService";
import { UserDetailsType } from "../../../types/genericType";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import UserDrawer from "../../../components/userDrawer/UserDrawer";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedUser } from "../../../redux/features/userSlice";
import { useClientDetails } from "../../../hooks/useClientDetails";
import { setClientDetails } from "../../../redux/features/clientDetailsSlice";

const Users = () => {
  const [usersData, setUsersData] = useState<UserDetailsType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const { selectedUser } = useSelector((state: any) => state.userState);
  const { clientOptions } = useClientDetails();

  const dispatch = useDispatch();

  const getUsersData = () => {
    setIsLoading(true);
    getAllUsers()
      .then((res) => {
        setUsersData(res);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const getUserData = (id: number) => {
    getUserDetails(id)
      .then((res) => {
        dispatch(setSelectedUser(res));
        setOpenEditDrawer(true);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  useEffect(() => {
    getUsersData();
  }, []);

  useEffect(() => {
    dispatch(setClientDetails(clientOptions));
  }, [clientOptions]);

  return (
    <>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography className="title">Users</Typography>
        <UserDrawer
          getUsersData={getUsersData}
          openEditDrawer={openEditDrawer}
          setOpenEditDrawer={setOpenEditDrawer}
          selectedUser={selectedUser}
        />
      </Toolbar>
      {!isLoading ? (
        <UsersTable data={usersData} onEditClick={getUserData} />
      ) : (
        <TableRowsLoader rowsNum={10} />
      )}
    </>
  );
};

export default Users;
